import { IFormSchema } from "@graffer-inc/form-schema";

export const InitialMetaInfoMapping: IFormSchema = {
  root: [
    {
      id: "",
      title: "申請メタ情報",
      elementType: "section",
      children: [
        {
          id: "applicationId",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請番号",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdWarekiEra",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請日元号",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdWarekiYear",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請年（和暦）",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdYear",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請年（西暦）",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdMonth",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請月",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdDay",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請日",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
        {
          id: "createdWeekDay",
          elementType: "input",
          inputType: "text",
          label: {
            text: "申請曜日",
            shouldDisplay: true,
          },
          description: {
            text: "",
            shouldDisplay: true,
          },
          required: false,
          placeholder: "",
          validations: [],
        },
      ],
    },
  ],
  version: "1.0.0",
};
